module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/january-eb4a744a30875f7ef19d9dda8a9e8c4b.png";